import * as React from 'react'
import { scaleImageUrl } from '../../../../../utils/image'

// Note on picture:
// Browsers which do not support picture still need to trigger onLoad and onError so it must
// be in the img tag. Browsers which do support picture, understand that these events should
// trigger even if they use the WebP source.

interface BasicImageProps {
  url: string
  alternateText?: string
  defaultWidth: number
  loading?: "eager" | "lazy"
  onError?: (event: React.SyntheticEvent<HTMLImageElement>) => void
  onLoad?: (event: React.SyntheticEvent<HTMLImageElement>) => void
  legacy?: boolean
  className?: string
}

//TS React doesn't know about this attribute by default
declare module 'react' {
  interface ImgHTMLAttributes<T> extends React.HTMLAttributes<T> {
    loading?: 'lazy' | 'eager';
  }
}

const BasicImage = ({ url, alternateText, defaultWidth, loading, onError, onLoad, legacy, className }: BasicImageProps) => {

  const imgTag = (<img onError={onError} onLoad={onLoad}
    src={scaleImageUrl(url, defaultWidth, 'jpg')}
    alt={alternateText}
    loading={loading} className={className} />)
  if (legacy)
    return imgTag
  return (
    <picture>
      <source
        type="image/webp"
        srcSet={`${scaleImageUrl(url, defaultWidth, 'webp')} 1x,
               ${scaleImageUrl(url, defaultWidth * 2, 'webp')} 2x`}
      />
      <source
        srcSet={`${scaleImageUrl(url, defaultWidth, 'jpg')} 1x,
               ${scaleImageUrl(url, defaultWidth * 2, 'jpg')} 2x`}
      />
      {imgTag}
    </picture>)
}

export default BasicImage
